// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "chartkick"
import "chartkick/chart.js"

// Make bootstrap globally available
window.bootstrap = bootstrap

// Initialize all tooltips and popovers
document.addEventListener("turbo:load", () => {
  // Initialize tooltips everywhere
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map((tooltipTriggerEl) => {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  // Initialize popovers everywhere
  const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  popoverTriggerList.map((popoverTriggerEl) => {
    return new bootstrap.Popover(popoverTriggerEl)
  })
})

// Action Cable setup
import { createConsumer } from "@rails/actioncable"
window.App || (window.App = {});
window.App.cable = createConsumer();

// Add a global message interceptor for debugging and emergency handling
const originalConsumerConnect = window.App.cable.connect.bind(window.App.cable);
window.App.cable.connect = function() {
  console.log('ActionCable connecting with interceptor active');
  const result = originalConsumerConnect();
  
  // Add global message interceptor
  const originalConsumerDispatch = window.App.cable.consumer.connection.webSocket.onmessage;
  window.App.cable.consumer.connection.webSocket.onmessage = function(event) {
    try {
      const data = JSON.parse(event.data);
      console.log('ActionCable raw message intercepted:', data);
      
      // Emergency payment success handler
      if (data.message && typeof data.message === 'object') {
        // Check if this is a payment success message in any format
        if (data.message.action === 'payment_success' && data.message.redirect_url) {
          console.log('EMERGENCY: Payment success detected in raw message!', data.message);
          
          // Show success notification
          const notification = document.createElement('div');
          notification.style.position = 'fixed';
          notification.style.top = '20px';
          notification.style.left = '50%';
          notification.style.transform = 'translateX(-50%)';
          notification.style.padding = '15px 20px';
          notification.style.backgroundColor = '#FF4500'; // Orange-red for emergency
          notification.style.color = 'white';
          notification.style.borderRadius = '4px';
          notification.style.zIndex = '10000';
          notification.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
          notification.textContent = 'EMERGENCY REDIRECT: Payment successful! Redirecting...';
          document.body.appendChild(notification);
          
          // Force redirect after a short delay
          setTimeout(() => {
            window.location.href = data.message.redirect_url;
          }, 1000);
        }
      }
    } catch (e) {
      console.error('Error in ActionCable message interceptor:', e);
    }
    
    // Always call the original handler
    return originalConsumerDispatch(event);
  };
  
  return result;
};

// Import channels
import "./channels"

// Global payment success handler
document.addEventListener("turbo:load", () => {
  // Get the current user ID if available
  const userElement = document.querySelector('[data-user-id]');
  const signedInUserElement = document.querySelector('[data-signed-in-user]');
  
  if (userElement || signedInUserElement) {
    const userId = userElement?.dataset.userId;
    const turboChannelId = signedInUserElement?.dataset.signedInUser;
    
    console.log('Setting up global payment success handler for user:', userId || turboChannelId);
    
    // Subscribe to user-specific channel for payment notifications
    if (userId) {
      console.log(`Subscribing to user_credits_${userId} channel`);
      window.App.paymentChannel = window.App.cable.subscriptions.create(
        { channel: "UserCreditsChannel", id: userId },
        {
          connected: () => console.log('Global payment handler connected to UserCreditsChannel'),
          disconnected: () => console.log('Global payment handler disconnected from UserCreditsChannel'),
          received: (data) => {
            console.log('Global payment handler received data:', data);
            
            if (data.action === 'payment_success' && data.redirect_url) {
              console.log('Payment successful, redirecting to:', data.redirect_url);
              
              // Show success notification
              const notification = document.createElement('div');
              notification.style.position = 'fixed';
              notification.style.top = '20px';
              notification.style.left = '50%';
              notification.style.transform = 'translateX(-50%)';
              notification.style.padding = '15px 20px';
              notification.style.backgroundColor = '#4CAF50';
              notification.style.color = 'white';
              notification.style.borderRadius = '4px';
              notification.style.zIndex = '10000';
              notification.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
              notification.textContent = 'Payment successful! Redirecting...';
              document.body.appendChild(notification);
              
              // Redirect after a short delay
              setTimeout(() => {
                window.location.href = data.redirect_url;
              }, 1000);
            }
          }
        }
      );
    }
    
    // Also subscribe to Turbo::StreamsChannel format if available
    if (turboChannelId) {
      window.App.turboPaymentChannel = window.App.cable.subscriptions.create(
        { channel: "Turbo::StreamsChannel", signed_stream_name: turboChannelId },
        {
          connected: () => console.log('Global payment handler connected to Turbo::StreamsChannel'),
          disconnected: () => console.log('Global payment handler disconnected from Turbo::StreamsChannel'),
          received: (data) => {
            console.log('Global payment handler received Turbo data:', data);
            
            // Check if the data contains payment success information
            if (data.action === 'payment_success' && data.redirect_url) {
              console.log('Payment successful (Turbo), redirecting to:', data.redirect_url);
              
              // Show success notification
              const notification = document.createElement('div');
              notification.style.position = 'fixed';
              notification.style.top = '20px';
              notification.style.left = '50%';
              notification.style.transform = 'translateX(-50%)';
              notification.style.padding = '15px 20px';
              notification.style.backgroundColor = '#4CAF50';
              notification.style.color = 'white';
              notification.style.borderRadius = '4px';
              notification.style.zIndex = '10000';
              notification.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
              notification.textContent = 'Payment successful! Redirecting...';
              document.body.appendChild(notification);
              
              // Redirect after a short delay
              setTimeout(() => {
                window.location.href = data.redirect_url;
              }, 1000);
            }
          }
        }
      );
    }
  }
})
